module.exports = vendor_13d4fa;